export const PRODUCTS = {
  COLUMNS: {
    PRODUCT_ID: 'Product ID',
    PRODUCT_NAME: 'Product Name',
    PRODUCT_CATEGORIES: 'Product Categories',
    LAST_UPDATED: 'Last Updated',
  },
};
